// extracted by mini-css-extract-plugin
export default {"container":"UploadPhotoSelector_container__3LA4r","error":"UploadPhotoSelector_error__s7TXe"};